// removed by extract-text-webpack-plugin
module.exports = {"header":"_2b6pr_2b","toggle":"_34XuP_34","container":"S7cBf_S7","isOpen":"ZcjwR_Zc","content":"UNoZJ_UN"};


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/Toggle/Toggle.css
// module id = 741
// module chunks = 0